module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACgSURBVFiF7c6hEcJAAETRfycyg8dRQppA0EsaoAcMChdDLWmCEuLwzCByCDzmdg2zv4DdBymllFJKP7rc7qfrPO/dP7V3oLXt8H7VxY3thn4roxsrgoIbK4SCEyuGggtrgIIDa4KCGmuEghJrhuoyQ9tj2G3H8zQ9e5eMUB0SbFAtEixQPRLkUA8SpFAfEmRQLxIE0FLq6kamlFJK6f/7AKIVVfAOznC+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/ruleMore.png
// module id = C1pc
// module chunks = 1